import React, { useEffect } from "react";
import Healthabout from "./Healthabout";
import Healthservices from "./Healthservices";
import Bankingexplore from "./Bankingexplore";
import Healthsolution from "./Healthsolution";
import Healthbanner from "./Healthbanner";

const Healthsci= () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div
      style={{
        // backgroundImage:
        //   "url('/image/3662a43d-artificial-intelligence.jpeg.optimal.jpeg')",
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundAttachment: "fixed",
        backgroundRepeat: "no-repeat",
        minHeight: "100vh",
        width: "100%",
        backgroundColor:"white",
      }}
    >
      <div style={{ backgroundColor: "rgba(255, 255, 255, 0.1)" }}>
        <Healthbanner/>
        <Healthabout/>
        <Healthservices/>

        {/* <Bankingexplore/> */}
        <Healthsolution/>
      </div>
    </div>
  );
};

export default Healthsci;
